module.exports = __webpack_public_path__ + "img/delete.81d5cfb9.svg";